/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IRegistrationInputOldExpiredTrialCancellation,
  IRegistrationInputCreateAccount,
  IRegistrationInputCompleteUser,
} from '../types/request.types'
import {
  IRegistrationOutputExistingMembershipInfo,
  IGenericJSONMessage,
  IRegistrationOutputCompleteAccount,
  IAccountsOutputCreateAccount,
  IRegistrationOutputCompleteUser,
} from '../types/response.types'

export default new class RegistrationAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_ExistingMembershipInfo(
    donedone_token: string,
    gauth_token: string,
  ): Promise<IRegistrationOutputExistingMembershipInfo> {
    return await this.get({
      url: `/registration/account/existing-membership-info`,
      params: {
        donedone_token,
        gauth_token,
      },
    })
  }
  public async get_ExpiredTrialExtension(
    donedone_token: string,
    gauth_token: string,
  ): Promise<IGenericJSONMessage> {
    return await this.get({
      url: `/registration/account/expired-trial-extension`,
      params: {
        donedone_token,
        gauth_token,
      },
    })
  }
  public async get_CompleteAccount(
    donedone_token: string,
    gauth_token: string,
  ): Promise<IRegistrationOutputCompleteAccount> {
    return await this.get({
      url: `/registration/account/complete`,
      params: {
        donedone_token,
        gauth_token,
      },
    })
  }
  public async get_CompleteUser(
    via_google_auth: boolean,
    token: string,
  ): Promise<IRegistrationOutputCompleteUser> {
    return await this.get({
      url: `/registration/user/complete`,
      params: {
        via_google_auth,
        token,
      },
    })
  }
  /****** POST methods *****/
  public async post_OldExpiredTrialCancellation(
    data: IRegistrationInputOldExpiredTrialCancellation,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/registration/account/old-expired-trial-cancellation`,
      data,
    })
  }
  public async post_CreateAccount(
    data: IRegistrationInputCreateAccount,
  ): Promise<IAccountsOutputCreateAccount> {
    return await this.post({
      url: `/registration/account/create`,
      data,
    })
  }
  public async post_CompleteUser(
    data: IRegistrationInputCompleteUser,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/registration/user/complete`,
      data,
    })
  }
}()
